export default __webpack_public_path__ + "static/media/tech-support.c5bef4e2.png";